import React from "react"
import Alert from "@meridian/components/alert";

export default function AppAlert(props) {

    return props.show && <Alert size={"medium"} type={props.type} onClose={props.onClose}>
        {props.message}
    </Alert>;
}


// WEBPACK FOOTER //
// ./src/components/app-alert.js